/**
 * 合同管理 Saga集合
 */
import contractlist from './contractlist/model';
import templatetrac from './templatetrac/model';

export default [
    ...Object.values(contractlist.sagas), // 合同列表
    ...Object.values(templatetrac.sagas), // 合同模板
];
